<template>
  <nav
    class="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-dark-bgbbnav flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6"
  >
    <div
      class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto"
    >
      <!-- Toggler -->
      <button
        class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
        type="button"
        v-on:click="toggleCollapseShow('bg-dark-bgbbnav m-2 py-3 px-6')"
      >
        <i class="text-bgbb-y fas fa-bars"></i>
      </button>

      <!-- WALLET BUTTON -->
      <button v-on:click="login"
        class="bg-dark text-dark bg-bgbb-y text-xs font-bold mb:pb-2 px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mb-12 mb-3 mt-3"
        type="button"
      >

       <span class="fas fa-wallet mr-2"> </span>


<span id="account" class="mr-2 specialspan">CONNECT WALLET</span> 
      </button>
      
       <button v-show="logOutvisible" type="button" v-on:click="logout"> <i class="fas fa-sign-out-alt"></i></button>
      
      <!-- WALLET BUTTON -->

      <ul class="md:hidden items-center flex flex-wrap list-none">
        <li class="inline-block relative">
          <!-- <notification-dropdown /> -->
        </li>
      </ul>
      <!-- Collapse -->
      <div
        class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-50 bg-dark-bgbbnavs overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
        v-bind:class="collapseShow"
      >
        <!-- Collapse header -->
        <div
          class="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200"
        >
          <div class="flex flex-wrap">
            <div class="w-6/12">
              <!-- CONNECTED WALLET COLLAPSED MENU-->

              <span
                class="mr-2 bg-bgbb-y p-1 px-2 rounded-full text-dark text-sm"
              >       <span class="fas fa-wallet mr-2"> </span>

                <span id="account2" class="specialspan mr-2"></span>

                
              </span>

              <!-- CONNECTED WALLET COLLAPSED MENU-->

              <!-- WALLET BUTTON -->

              <!-- 
    <button
              class="bg-dark text-dark bg-bgbb-y text-xs font-bold uppercase mb:pb-2 px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none lg:mr-1 lg:mb-0 mb-3 ease-linear transition-all duration-150"
              type="button"
            >
             connect wallet
            </button> -->
              <!-- WALLET BUTTON -->
            </div>
            <div class="w-6/12 flex justify-end">
              <button
                type="button"
                class="shadow-2xl cursor-pointer text-bgbb-y opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                v-on:click="toggleCollapseShow('hidden')"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Form -->
        <!-- <form class="mt-6 mb-4 md:hidden">
          <div class="mb-3 pt-0">
            <input
              type="text"
              placeholder="Search"
              class="px-3 py-2 h-12 border border-solid border-blueGray-500 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-base leading-snug shadow-none outline-none focus:outline-none w-full font-normal"
            />
          </div>
        </form> -->

        <!-- Divider -->

        <!-- Heading -->
        <h6
          class="md:min-w-full text-white text-m block pt-1 pb-4 no-underline"
        >
          Staking
        </h6>
        <!-- Navigation -->

        <ul class="md:flex-col md:min-w-full flex flex-col list-none">
          <li class="items-center">
            <router-link to="/staking" v-slot="{ href, navigate, isActive }">
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-bgbb-y hover:text-bgbb-y'
                    : 'text-white hover:text-white',
                ]"
              >
                <i
                  class="fas fa-hourglass-half mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-blueGray-300']"
                ></i
                >Regular Staking
              </a>
            </router-link>
          </li>

          <li class="items-center">
            <router-link
              to="/insurance-staking"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-bgbb-y hover:text-bgbb-y'
                    : 'text-white hover:text-white',
                ]"
              >
                <i
                  class="fas fa-shield-alt mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-blueGray-300']"
                ></i
                >Insurance Staking
              </a>
            </router-link>
          </li>

          <li class="items-center">
            <router-link
              to="/bulk-staking"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-bgbb-y hover:text-bgbb-y'
                    : 'text-white hover:text-white',
                ]"
              >
                <i
                  class="fas fa-history mr-2 text-sm flipped"
                  :class="[isActive ? 'opacity-75' : 'text-blueGray-300']"
                ></i
                >Bulk Staking
              </a>
            </router-link>
          </li>

          <li class="items-center">
            <router-link
              to="/collateral-staking"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-bgbb-y hover:text-bgbb-y'
                    : 'text-white hover:text-white',
                ]"
              >
                <i
                  class="fas fa-landmark mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-blueGray-300']"
                ></i
                >Collateral Staking
              </a>
            </router-link>
          </li>
        </ul>

        <!-- Divider -->
        <hr class="my-4 md:min-w-full" />
        <!-- Heading -->

        <!-- Navigation -->

        <ul class="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
          <li class="items-center">
            <router-link to="/swap" v-slot="{ href, navigate, isActive }">
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-bgbb-y hover:text-bgbb-y'
                    : 'text-white hover:text-white',
                ]"
              >
                <i
                  class="fas fa-exchange-alt mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-blueGray-300']"
                ></i
                >Swap Tokens
              </a>
            </router-link>
          </li>

          <li class="items-center">
            <router-link
              to="/staking-pools"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-bgbb-y hover:text-bgbb-y'
                    : 'text-white hover:text-white',
                ]"
              >
                <i
                  class="fas fa-tint mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-blueGray-300']"
                ></i
                >Staking Pools <span class="text-xs">[soon]</span>
              </a>
            </router-link>
          </li>

          <li class="items-center">
            <router-link to="/governance" v-slot="{ href, navigate, isActive }">
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-bgbb-y hover:text-bgbb-y'
                    : 'text-white hover:text-white',
                ]"
              >
                <i
                  class="fas fa-gavel mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-blueGray-300']"
                ></i
                >Governance <span class="text-xs">[soon]</span>
              </a>
            </router-link>
          </li>
        </ul>

        <!-- Divider -->
        <hr class="my-4 md:min-w-full" />
        <!-- Heading -->
        <h6
          class="md:min-w-full text-white text-m block pt-1 pb-4 no-underline"
        >
          Referral System
        </h6>
        <!-- Navigation -->

        <ul class="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
          <li class="items-center">
            <router-link
              to="/referral-status"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-bgbb-y hover:text-bgbb-y'
                    : 'text-white hover:text-white',
                ]"
              >
                <i
                  class="fas fa-user-plus mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-blueGray-300']"
                ></i
                >Status
              </a>
            </router-link>
          </li>

          <li class="items-center">
            <router-link
              to="/referral-link"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-bgbb-y hover:text-bgbb-y'
                    : 'text-white hover:text-white',
                ]"
              >
                <i
                  class="fas fa-link mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-blueGray-300']"
                ></i
                >Referral Link
              </a>
            </router-link>
          </li>

          <hr class="my-4 md:min-w-full" />
        </ul>
        <!-- Divider -->


  <ul class="md:flex-col md:min-w-full flex flex-col list-none md:mb-4">
          <li class="items-center">
            <router-link
              to="/NFT-marketplace"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-bgbb-y hover:text-bgbb-y'
                    : 'text-white hover:text-white',
                ]"
              >
                <i
                  class="fas fa-shapes mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-blueGray-300']"
                ></i
                >Visit NFT Marketplace
              </a>
            </router-link>
          </li>
          




            <li class="items-center">
            <router-link
              to="/"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-xs uppercase py-3 font-bold block"
                :class="[
                  isActive
                    ? 'text-bgbb-y hover:text-bgbb-y'
                    : 'text-white hover:text-white',
                ]"
              >
                <i
                  class="fas fa-arrow-alt-circle-left mr-2 text-sm"
                  :class="[isActive ? 'opacity-75' : 'text-blueGray-300']"
                ></i
                >Homepage
              </a>
            </router-link>
          </li>
                
          
          </ul>



        <!-- Heading -->
      </div>
    </div>
  </nav>
</template>
); }

<script>
// import NotificationDropdown from "@/components/Dropdowns/NotificationDropdown.vue";
// import UserDropdown from "@/components/Dropdowns/UserDropdown.vue";
import Web3 from 'web3';
const Moralis = require('moralis');
let data = new Moralis.Web3();
console.log('Moralis');
console.log(data);
Moralis.initialize("pjx5QzyCaQSkMthScEsv06x3jkxt0eW2TQwlsiAj", "nUrvbOC5ExJBgj8b6gOOMKAN2GERL1vGe1wHmCG4");
Moralis.serverURL = 'https://b6r7kfexiuct.moralis.io:2053/server';
let web3 = new Web3('ws://localhost:3000');
console.log('WEB 3');
console.log(web3);



const NODE_URL = "https://speedy-nodes-nyc.moralis.io/8e9707e6b8f5a3a0d708309e/bsc/testnet";
const provider = new Web3.providers.HttpProvider(NODE_URL);
const web33 = new Web3(provider);
console.log(web33);





export default {
  data() {
    return {
      collapseShow: "hidden",
        logOutvisible: true,
    };
  },
  methods: {
    getAddress: function() {
       console.log('ON LOAD');   
    },
    toggleCollapseShow: function (classes) {
      this.collapseShow = classes;
    },
     async getUser(){
        console.log(web3);  
    },
    login(){
        Moralis.Web3.authenticate().then(function (user) {
        console.log('MORALIS SUCCESS');
        console.log(user.get('ethAddress'));  
        const template = document.getElementById('account');
        const template2 = document.getElementById('account2');
        // template.innerHTML = userAddress;
        var string = user.get('ethAddress');
        var strshortened = string.slice(0,6);
        console.log(template.innerHTML);
        console.log('First 6');
        console.log(strshortened);
        console.log('Last 4');
        var lastFour = string.substr(string.length - 4);
        console.log(lastFour);
        var elipses = "...";
        var finalwallet = strshortened + elipses + lastFour;
        console.log(finalwallet);
        template.innerHTML = finalwallet;
        template2.innerHTML = finalwallet;
         
        });
        this.logOutvisible = true;
     },
     logout(){
         console.log('LOGOUT');
          Moralis.User.logOut();
           const template = document.getElementById('account');
           const template2 = document.getElementById('account2');
          template.innerHTML = "CONNECT WALLET";
          template2.innerHTML = "CONNECT WALLET";
          this.logOutvisible = false;
      }  
  },
  beforeMount(){
    this.getAddress()
  },
  components: {
    // NotificationDropdown,
    // UserDropdown,
  },
  mounted() {
    if(!Moralis.User.current()){
         this.logOutvisible = false;
    }else{
          const user = Moralis.User.current();
          const string = user.get("ethAddress");
          console.log('ADDRESS');
          console.log(string);  
          const template = document.getElementById('account');   
          const template2 = document.getElementById('account2');
          var strshortened = string.slice(0,6);
          var lastFour = string.substr(string.length - 4);
          var elipses = "...";
          var finalwallet = strshortened + elipses + lastFour;
          template.innerHTML = finalwallet;
          template2.innerHTML = finalwallet;  
       }
  },
};
</script>
